import React from 'react';
import { getText } from '../../utils/functions';
import { useIcons } from '../../utils/hooks';
import ValidationWrapper from '../validation/ValidationWrapper';

function CheckboxInput({
	name,
	value, // will always be an []
	items,
	onChange = () => {},
	maxSelections = 1,
	minSelections = 1,
	uniqueValues = [],
	colors,
	required,
	checkbbdd,
	translate,

	/* OPTIONAL PROPS */
	id,
	isVote,
	confirmValue,
	confirmError,
	classNameDIV = 'flex flex-col w-full space-y-3 focus:outline-none outline-none',
	styleDIV,
	styleWRAPPER,
}) {
	/* Simple function to check if an item is checked */
	const isChecked = val => value !== null && value !== undefined && value.length > 0 && value.includes(val);

	/* Default values for the styles */
	const defaultStyleDIV = {
		color: colors?.primary
	};
	const defaultStyleWRAPPER = {
		borderBottom: null,
	};

	/* This way you can modify or add fields without affecting the others */
	const overrideStyleDIV = { ...defaultStyleDIV, ...styleDIV };
	const overrideStyleWRAPPER = { ...defaultStyleWRAPPER, ...styleWRAPPER };

	/* Checks if a UniqueValue is selected */
	const isUniqueValueSelected = () => {
		let check = false;
		uniqueValues.forEach(val => {
			if (value !== null && value !== undefined && value.includes(val)) {
				check = true;
			}
		});
		return check;
	};

	/* Simple function to check if an item is disabled */
	const isDisabled = val => value !== null && value !== undefined
		&& !value.includes(val)
		&& (value.length === maxSelections || isUniqueValueSelected());

	/* We handle the special change logic */
	const handleChange = itemValue => {
		/* IF unchecking a box */
		if (isChecked(itemValue)) {
			onChange([...value.filter(va => va !== itemValue)]);
			return;
		}
		/* If adding uniqueValue */
		if (uniqueValues.includes(itemValue)) {
			onChange([itemValue]);
			return;
		}
		/* If trying to check above the check limit */
		if (value !== null && value !== undefined && value.length === maxSelections) {
			// SHOW ERROR
			return;
		}
		/* If trying to add when an uniqueValue is selected */
		if (isUniqueValueSelected()) {
			// SHOW ERROR
			return;
		}
		/* Add value to array */
		if (value !== null && value !== undefined) {
			onChange([...value, itemValue]);
			return;
		}
		onChange([itemValue]);
	};

	return <ValidationWrapper
		value={value}
		name={name}
		required={required}
		checkbbdd={checkbbdd}
		colors={colors}
		keepEmptySpace={false}
		errorOnTop={true}
		isVote={isVote}
		isValueArray={true}
		uniqueValues={uniqueValues}
		minSelections={minSelections}
		confirmValue={confirmValue}
		styleDIV={overrideStyleWRAPPER}
		confirmError={confirmError}
	>
		<div
			id={id}
			className={classNameDIV}
			style={overrideStyleDIV}
		>
			{items.map(item => <CheckboxItem
				item={item}
				key={item.value}
				checked={isChecked(item.value)}
				disabled={isDisabled(item.value)}
				onClick={handleChange}
				colors={colors}
				translate={translate}
			/>)}
		</div>
	</ValidationWrapper>;
}

function CheckboxItem({
	item,
	checked,
	onClick,
	colors,
	translate,
	disabled,

	/* OPTIONAL PROPS */
	styleSPAN,
	classNameITEM = 'flex space-x-3 w-max items-center cursor-pointer',
	classNameIMG = 'self-center',
	classNameSPAN = 'text-base',
}) {
	/* Icon hook */
	const { Box, BoxSelected } = useIcons(colors);

	/* Default values for the styles */


	/* Default values for the styles */
	const defaultStyleSPAN = {
		color: disabled ? colors?.deactivated : colors?.text
	};

	/* This way you can modify or add fields without affecting the others */

	const overrideStyleSPAN = { ...defaultStyleSPAN, ...styleSPAN };


	return <div
		className={classNameITEM}
		key={item.value}
		onClick={() => onClick(item.value)}
	>
		{checked ?
			BoxSelected && BoxSelected({ className: classNameIMG })
			: Box && Box({ className: classNameIMG })
		}
		<span
			style={overrideStyleSPAN}
			className={classNameSPAN}
		>
			{getText(item, translate)}
		</span>
	</div>;
}

export default CheckboxInput;
